import { createOperation } from "src/features/operations";

export const resetOpenTableDateToSubmitOperation = createOperation<void>("OPEN_TABLE/RESET_DATE_TO_SUBMIT");

export const submitOpenTableOrderOperation = createOperation<void>("OPEN_TABLE/SUBMIT_ORDER", { allowParallel: false });
